<template>
<div>
    <div class="wrapper section_wrapper section_client_home_wrapper">
        <div class="container">
            <div class="column_wrapper column_wrapper_right client_home_content_wrapper">
                <div class="column_container client_home_content_container">
                    <div class="section_title">Macquarie Group Services</div>
                    <div class="section_content">
                        <p style="padding-bottom:1.3em;">Macquarie Group Services (MGS) provides products and services to the accounting, legal and financial planning professions. Established in 1999, the company has grown in reputation and size over the last 20 years. MGS provides cutting edge up to date solutions whether your client is acquiring a townhouse or wishes to do a corporate consolidation/reconstruction. Browse our site, or call us to find out about our trust deeds, super funds, companies, precedent documents, online technical updating and education.</p>
                        <a class="btn btn-primary" href="javascript:void(0)" @click="$root.set_page('/client/documents')">Order Documents</a>
                    </div>
                </div>
                <div class="column_container client_home_thumb_container">
                    <img src="/assets/image/client-panel/section-client-home-thumb.jpg">
                </div>
            </div>
        </div>
    </div>
    <div class="wrapper section_wrapper section_introduction_wrapper">
        <div class="container">
            <div class="introduction_content_container">
                <div class="section_title introduction_title">Macquarie Group Services</div>
                <div class="section_content introduction_content">
                    <p>Macquarie Group Services (MGS) provides products and services to the accounting, legal and financial planning professions. Established in 1999, the company has grown in reputation and size over the last 20 years. MGS provides cutting edge up to date solutions whether your client is acquiring a townhouse or wishes to do a corporate consolidation/reconstruction. Browse our site, or call us to find out about our trust deeds, super funds, companies, precedent documents, online technical updating and education.</p>
                </div>
            </div>
            <div class="introduction_link_container">
                <a class="introduction_link" href="javascript:void(0)" @click="$root.set_page('/client/webinar')">
                    <img class="introduction_icon" src="/assets/image/introduction/home-icon-webinar.png">
                    <span class="introduction_label">Webinar</span>
                </a>
                <a class="introduction_link" href="javascript:void(0)" @click="$root.set_page('/client/about-mgs-private')">
                    <img class="introduction_icon" src="/assets/image/introduction/home-icon-private.png">
                    <span class="introduction_label">About MGS Private</span>
                </a>
                <a class="introduction_link" href="javascript:void(0)" @click="$root.set_page('/client/high-wealth-individuals')">
                    <img class="introduction_icon" src="/assets/image/introduction/home-icon-wealth.png">
                    <span class="introduction_label">High Wealth Individuals</span>
                </a>
                <a class="introduction_link" href="javascript:void(0)" @click="$root.set_page('/client/bomad-trusts')">
                    <img class="introduction_icon" src="/assets/image/introduction/home-icon-bomad.png">
                    <span class="introduction_label">BOMAD Trusts</span>
                </a>
                <a class="introduction_link" href="javascript:void(0)" @click="$root.set_page('/client/trusts')">
                    <img class="introduction_icon" src="/assets/image/introduction/home-icon-trusts.png">
                    <span class="introduction_label">MGS Trusts</span>
                </a>
                <a class="introduction_link" href="javascript:void(0)" @click="$root.set_page('/client/succession-trusts')">
                    <img class="introduction_icon" src="/assets/image/introduction/home-icon-succession.png">
                    <span class="introduction_label">Succession Trusts</span>
                </a>
            </div>
        </div>
    </div>
    <div class="wrapper section_wrapper section_offer_wrapper">
        <div class="container">
            <div class="offer_content_container">
                <div class="section_title offer_title">What we offer</div>
                <div class="section_content offer_content">
                    <p>Macquarie Group Services offers a wide range of products and services to professinoals across Australia. From company,
                        Trust and SMSF creation and maintenance to tax advice on complex issues. We have been providing expert, high quality
                        services for more than 20 years from our Sydney location and have earned a reputation as the go-to for everything tax.
                        Check out our range of products and services below and find out how we can help you and your clients. </p>
                </div>
                <div class="offer_link_container">
                    <a href="javascript:void(0)" @click="$root.set_page('/client/products')" class="btn offer_button">View Products</a>
                    <a href="javascript:void(0)" @click="$root.set_page('/client/about-mgs-private')" class="btn offer_button">View Services</a>
                </div>
            </div>
        </div>
    </div>
    <div class="wrapper section_wrapper section_topics_wrapper">
        <div class="container">
            <div class="touch_slider_wrapper">
                <div class="navigation_button_container touch_slider_navigation_dot_container">
                    <div class="topic_title touch_slider_navigation_dot btn btn-secondary" v-for="(topic,topic_index) in topic_list" v-html="topic.title" @click="set_topic(topic_index)"></div>
                </div>
                <div class="touch_slider_container">
                    <div class="leading_block" :style="{'margin-left':-100*(topic_index-0)+'%'}"></div>
                    <div class="touch_slider_item_content_container" v-for="topic in topic_list">
                        <div class="topic_container">
                            <img class="topic_thumb" :src="topic.thumb">
                            <p class="topic_summary_text" v-html="topic.summary"></p>
                            <a v-if="topic.download" class="topic_thumb_link btn btn-primary" :href="topic.link" :download="topic.download" target="_blank">Download Now</a>
                            <a v-else class="topic_thumb_link btn btn-primary" href="javascript:void(0)" :title="topic.title" @click="$root.set_page(topic.link)">Learn More</a>
<!--                            <a class="topic_thumb_link btn btn-primary" href="javascript:void(0)" :title="topic.title" @click="$root.set_page(topic.link)">View Now</a>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="wrapper section_wrapper section_macquarietv_wrapper">
        <div class="container">
            <div class="macquarietv_logo_container"><img src="/assets/image/macquarie-tv-logo-light.png"></div>
            <div class="macquarietv_content_container">
                <div class="section_title macquarietv_title">Earn CPE/CPD/CLE credits directly from your desktop</div>
                <div class="section_content macquarietv_content">
                    <p>Benefit  from expert commentary on hot tax topics of the moment, broadcasted directly to your home or office through your broadband internet connection.</p>
                </div>
            </div>
            <div class="macquarietv_link_container">
                <a class="btn btn-primary" href="https://www.macquarie.tv/home" target="_blank">Learn More</a>
            </div>
        </div>
    </div>
    <div id="contact_us" class="wrapper section_wrapper section_bottom_contact_wrapper">
        <div class="container">
            <div class="bottom_contact_subtitle">Still have questions?</div>
            <div class="section_title bottom_contact_title">Feel Free to Get in Touch With us</div>
            <div class="section_content bottom_contact_content">
                <div class="bottom_contact_content_column">
                    <div class="bottom_contact_content_row">You can find us here:</div>
                    <div class="bottom_contact_content_row"><span class="bottom_contact_address">Level 7, 77 Castlereagh St, Sydney, 2000</span></div>
                </div>
                <div class="bottom_contact_content_column">
                    <div class="bottom_contact_content_row"><span class="highlight_text">Postal Address:</span> GPO Box 512</div>
                    <div class="bottom_contact_content_row">Sydney, NSW 2001, Australia</div>
                </div>
                <div class="bottom_contact_content_column">
                    <div class="bottom_contact_content_row"><span class="highlight_text">Phone:</span> (02) 9231 5111</div>
                    <div class="bottom_contact_content_row"><span class="highlight_text">Email:</span> contact@macquariegs.com.au</div>
                </div>
            </div>
            <form-contact-us></form-contact-us>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: 'Home',
        data() {
            return {
                topic_index: 0,
                topic_list: [
                    {
                        title:'BOMAD Trust&trade; – A Financial tool to help your children buy a home',
                        summary:'Learn about a BOMAD Trust&trade; (Bank of Mum and Dad Trust), a type of Discretionary Trust that parents can use to securely provide financial assistance to their child for buying a house which provides protections and clarity for all involved.',
                        thumb:'/assets/image/free-download/1.png',
                        link:'/assets/document/free-download/1.pdf',
                        download:'BOMAD Trust Brochure.pdf'
                    },
                    {
                        title:'BONAP Trust&trade; – A Financial tool to help your grandchildren buy a home',
                        summary:'Learn about a BONAP Trust&trade; (Bank of Nan and Pop Trust), which is similar to a BOMAD Trust&trade; but should be used in the situation where grandparents are providing the financial assistance to a grandchild buying a home.',
                        thumb:'/assets/image/free-download/2.png',
                        link:'/assets/document/free-download/2.pdf',
                        download:'BONAP Trust Brochure.pdf',
                    },
                    {
                        title:'Succession Trusts – Plan your family’s future with confidence',
                        summary:'Learn about Succession Trusts, a type of Trust that can be used to manage the transfer of wealth from one generation to the next with a range of controls and protections to ensure your wishes are fulfilled. Unlike a Will, a Succession trust provides certainty.',
                        thumb:'/assets/image/free-download/3.png',
                        link:'/assets/document/free-download/3.pdf',
                        download:'Succession Trust Brochure.pdf',
                    },
                    {
                        title:'Property development structures - Asset protection',
                        summary:'Following the Designers and Building Practitioners Act 2020, developers need to consider how to structure developments so that retained property may be moved away from the development entity without income tax, GST, or duty if structured correctly.',
                        thumb:'/assets/image/free-download/4.png',
                        link:'/client/property-development-structures-asset-protection'
                    },
                    {
                        title:'NSW Land Tax Strategies',
                        summary:'Many New South Wales property investors are becoming increasingly frustrated with the land tax being imposed on their properties as land values rise. There are strategies available to help you minimise the impact incidence of land tax whether you own 1 or 10 properties.',
                        thumb:'/assets/image/free-download/5.png',
                        link:'/client/nsw-land-tax-strategy-trust-conversion-investment-property',
                    },
                ]
            }
        },
        methods: {
            set_topic: function(id) {
                this.topic_index = id;
                $('html, body').stop().animate({
                    scrollTop:$('.section_topics_wrapper').offset().top
                }, 550);
            }
        }
    }
</script>